import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard-3" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexEcommerce',
  setup(__props) {

const TotalSells = defineAsyncComponent(() => import("@/components/common/TotalSells.vue"))
const RecentOrders = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/RecentOrders.vue"))
const SalesOverview = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/SalesOverview.vue"))
const RecentCustomers = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/RecentCustomers.vue"))
const RevenueCategory = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/RevenueCategory.vue"))
const UserContinent = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/UserContinent.vue"))
const ProductDetail = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/ProductDetail.vue"))
const TopSeller = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/TopSeller.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TotalSells)),
      _createVNode(_unref(RecentOrders)),
      _createVNode(_unref(SalesOverview)),
      _createVNode(_unref(RecentCustomers)),
      _createVNode(_unref(RevenueCategory)),
      _createVNode(_unref(UserContinent)),
      _createVNode(_unref(ProductDetail)),
      _createVNode(_unref(TopSeller))
    ])
  ]))
}
}

})